import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';

import { DynamicPage } from './pages/dynamic-page/dynamic-page';
import { DynamicPageFull } from './pages/dynamic-page/dynamic-page.full';
import { DynamicPageCommon } from './pages/dynamic-page/dynamic-page.common';
import { DynamicHTMLModule } from '../dynamic-html/dynamic-html.module';

import { DynamicPageData }from'./providers/dynamic-page-data';
//Export
export { DynamicPage } from './pages/dynamic-page/dynamic-page';
export { DynamicPageFull } from './pages/dynamic-page/dynamic-page.full';

@NgModule({
    imports: [
        IonicModule,
        DynamicHTMLModule
    ],
    declarations: [
        DynamicPage,
        DynamicPageFull
    ],
    exports: [
        DynamicPage,
        DynamicPageFull
    ],
    bootstrap: [],
    entryComponents: [
        DynamicPage,
        DynamicPageFull
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}, DynamicPageData, DynamicPageCommon]
})
export class DynamicPageModule{
    constructor(public pageRef: PageRef){
       this.pageRef.addCfgLinks([
            { component: DynamicPage, fullComponent: DynamicPageFull,  name: 'Page', segment: 'page/:id' }
        ]) 
    }
}


// WEBPACK FOOTER //
// ./src/modules/dynamic-page/dynamic-page.module.ts